import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TableHead,
    Box,
    Autocomplete
} from '@mui/material';

function EntryDialog({ open, handleClose, selectedRow, accountDetails }) {
    const [rows, setRows] = useState([]);
    const [accountNames, setAccountNames] = useState([]);

    useEffect(() => {
        if (selectedRow) {
            setRows([
                {
                    code: selectedRow.accode, accountName: selectedRow.acname, debit: '', credit: ''
                },
                { code: '', accountName: null, debit: '', credit: '' },
                { code: '', accountName: null, debit: '', credit: '' },
            ]);
        }
    }, [selectedRow]);

    useEffect(() => {
        console.log(accountDetails);
        const a = accountDetails.map((datum) => {
            return {
                'id': datum.accode,
                'label': datum.acname
            }
        });
        setAccountNames(a);
    }, [accountDetails]);

    const handleAddRow = () => {
        setRows([...rows, { code: '', accountName: null, debit: '', credit: '' }]);
    };

    const handleRowChange = (index, field, value) => {
        console.log(index, field, value)
        setRows(prevRows =>
            prevRows.map((row, i) => {
                if (i !== index) return row;

                const updatedRow = { ...row };

                // If the field is 'accountName', update the 'code' field
                if (field === 'accountName' && value) {
                    updatedRow.accountName = value.label;
                    updatedRow.code = value.id;
                } else {
                    updatedRow[field] = value;
                }

                return updatedRow;
            })
        );
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
            <DialogTitle>Post Entries</DialogTitle>
            <DialogContent>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Code</TableCell>
                            <TableCell>Account Name</TableCell>
                            <TableCell>Debit</TableCell>
                            <TableCell>Credit</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell>
                                    <TextField
                                        value={row.code}
                                        onChange={(e) => handleRowChange(index, 'code', e.target.value)}
                                        variant="outlined"
                                        size="small"
                                        disabled={true}
                                        sx={{
                                            backgroundColor: '#f0f0f0',
                                            '& .MuiInputBase-input.Mui-disabled': {
                                                WebkitTextFillColor: '#a1a1a1',  // Set the text color to grey for disabled state
                                            },
                                        }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <Autocomplete
                                        options={accountNames}
                                        value={row.accountName}
                                        onChange={(event, newValue) => handleRowChange(index, 'accountName', newValue)}
                                        disabled={index === 0}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                size="small"
                                            />
                                        )}
                                        sx={{
                                            backgroundColor: index === 0 ? '#f0f0f0' : 'inherit',
                                            '& .MuiInputBase-input.Mui-disabled': {
                                                WebkitTextFillColor: '#a1a1a1',  // Set the text color to grey for disabled state
                                            },
                                        }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        value={row.debit}
                                        onChange={(e) => handleRowChange(index, 'debit', e.target.value)}
                                        variant="outlined"
                                        size="small"
                                        disabled={!!row.credit}  // Disable Debit if Credit has a value
                                        sx={{
                                            backgroundColor: !!row.credit ? '#f0f0f0' : 'inherit',
                                            '& .MuiInputBase-input.Mui-disabled': {
                                                WebkitTextFillColor: '#a1a1a1',  // Set the text color to grey for disabled state
                                            },
                                        }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        value={row.credit}
                                        onChange={(e) => handleRowChange(index, 'credit', e.target.value)}
                                        variant="outlined"
                                        size="small"
                                        disabled={!!row.debit}  // Disable Credit if Debit has a value
                                        sx={{
                                            backgroundColor: !!row.debit ? '#f0f0f0' : 'inherit',
                                            '& .MuiInputBase-input.Mui-disabled': {
                                                WebkitTextFillColor: '#a1a1a1',  // Set the text color to grey for disabled state
                                            },
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                    <Button variant="contained" color="primary" onClick={handleAddRow}>
                        Add Row
                    </Button>
                    <Button variant="outlined" color="primary">
                        Add New Account
                    </Button>
                </Box>

                <Box sx={{ mt: 3 }}>
                    <TextField
                        label="Narration"
                        multiline
                        rows={4}
                        fullWidth
                        variant="outlined"
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary">
                    Post Entries
                </Button>
                <Button variant="outlined" color="secondary" onClick={handleClose}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default EntryDialog;
